$(document).ready(function() {

  $('.generalmessage').prependTo('.header');

  const $footer = $('.footer');
  $footer.find('.emailSignupText').text('Get All The Latest Updates');
  $footer.find('.emailSubmitButton').text('Subscribe');
  $footer.find('.emailInputField input').val('');
  $footer.find('.emailInputField input').attr('placeholder', 'Email Address');

  $footer.find('.footerItems1 .separator').remove();

  $footer.find('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffireFooter-logo.png`);
});